<div class="claim-card w-full overflow-hidden break-words">
    <div class="border-b border-b-divider-divider last:border-b-0 w-full">
        <div>
            <div class="claim-card-body">
                <div class="claim-card-basicinfo">
                    <div>
                        <app-badge-status statusText="{{ claim.statusi18nkey || '' | translate }}" [iconClass]="this.claimActions[claim.status].iconBadgeClass || ''">
                        </app-badge-status>
                        <div style="word-wrap: break-word; margin-bottom: 0.5rem"></div>
                        <div style="word-wrap: break-word; margin-bottom: 0.5rem">
                            <span class="typography-body-m-light">
                                {{ 'global.subject' | translate }}: <span class="primaryDefault-color typography-body-m-medium">{{ claim.subject }}</span></span
                            >
                        </div>
                        <div style="word-wrap: break-word; margin-bottom: 0.5rem">
                            <span class="typography-body-m-light">
                                {{ 'global.created_at' | translate }}: <span class="primaryDefault-color typography-body-m-medium">{{ claim.createdAt | date }}</span></span
                            >
                        </div>
                        <ng-container *ngIf="claim.personalNote">
                            <div class="divider my-4 w-full"></div>
                            <div class="typography-body-s-regular" style="background: rgba(255, 246, 212, 0.5); padding: 8px">
                                {{ 'my_claims.your_notes' | translate }}:<br />
                                {{ claim.personalNote }}
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="divider lg:hidden"></div>
                <div class="claim-card-info">
                    <div class="claim-card-info-content lg:max-w-[160px]">
                        <div style="word-wrap: break-word; margin-bottom: 0.5rem">
                            <span class="typography-body-m-light">
                                {{ 'my_claims.incidence_number' | translate }}:<br />
                                <span class="primaryDefault-color typography-body-m-medium">{{ claim.caseNumber }}</span></span
                            >
                        </div>
                        <div *ngIf="claim.homeOwnerFirstName && claim.homeOwnerLastName" style="word-wrap: break-word; margin-bottom: 0.5rem">
                            <span class="typography-body-m-light">
                                {{ 'my_claims.customer' | translate }}: <br /><span class="primaryDefault-color typography-body-m-medium">{{ claim.finalCustomerName }}</span></span
                            >
                        </div>
                        <div *ngIf="claim.associatedWarranty" style="word-wrap: break-word; margin-bottom: 0.5rem">
                            <span class="typography-body-m-light">
                                {{ 'my_claims.warranty' | translate }}:<br />
                                <span class="primaryDefault-color typography-body-m-medium">{{ claim.associatedWarranty }}</span></span
                            >
                        </div>
                        <div *ngIf="claim.purchaseOrder" style="word-wrap: break-word; margin-bottom: 0.5rem">
                            <span class="typography-body-m-light">
                                {{ 'create-claim.purchase_order' | translate }}:<br />
                                <span class="primaryDefault-color typography-body-m-medium">{{ claim.purchaseOrder }}</span></span
                            >
                        </div>
                    </div>
                    <div class="divider lg:hidden"></div>
                    <div class="carousel">
                        <ngx-slick-carousel [config]="slideConfig" *ngIf="claim.claimItems.length > 0">
                            <div ngxSlickItem class="slide" *ngFor="let product of claim.claimItems">
                                <div class="product-card flex flex-col items-center" style="gap: 4px">
                                    <img
                                        *ngIf="product?.product?.pictureURL"
                                        src="{{ product.product.pictureURL }}?w=60&h=60&fit=crop"
                                        [alt]="product.product.colorDesc"
                                        class="w-[69px] h-[69px] rounded-full object-cover mb-2"
                                    />
                                    <app-cosentino-svg *ngIf="!product?.product?.pictureURL" [svgName]="'no-image'" [size]="72"></app-cosentino-svg>
                                    <span class="typography-title-s">{{ product.productName }}</span>
                                    <span class="typography-body-s-light">{{ product.productBrand }}</span>
                                    <span class="typography-body-s-light">{{ 'global.finish' | translate }}: {{ product.productFinish }}</span>
                                    <span class="typography-body-s-light">{{ 'global.thickness' | translate }}: {{ product.productThickness }}</span>
                                    <span class="typography-body-s-light" *ngIf="product.barCode">{{ 'global.lot_id' | translate }}: {{ product.barCode }}</span>
                                </div>
                            </div>
                        </ngx-slick-carousel>

                        <div class="product-card flex flex-col items-center" *ngIf="claim.claimItems.length == 0">
                            <app-cosentino-svg [svgName]="'no-image'" [size]="72"></app-cosentino-svg>
                        </div>
                    </div>
                </div>
                <div class="divider lg:hidden"></div>
                <div class="claim-card-action">
                    <div class="typography-title-s text-center">{{ claimActions[claim.status].title || '' | translate }}</div>
                    <div class="mt-2 typography-body-s font-light text-center">{{ claimActions[claim.status].subtitle || '' | translate }}</div>

                    <br />
                    <!-- El boton de accion es condicional si soy el tipo de usuario que corresponde a la interaccion -->
                    <div class="w-full pt-4">
                        <app-button [block]="true" [primary]="true" [gtmLabel]="'claim-card_button_' + (claimActions[claim.status].actionMessage === 'global.complete' ? 'complete-claim' : 'view-claim-detail')" (onClick)="claimActions[claim.status].actionFunction()">
                            {{ claimActions[claim.status].actionMessage || '' | translate }}
                        </app-button>
                    </div>

                    <!-- Caso excepcional. Borrado de pedido en DRAFT -->
                    <div class="w-full pt-4">
                        <app-button [block]="true" [link]="true" [ghost]="true" *ngIf="claim.status === 'DRAFT'" [gtmLabel]="'claim-card_link_delete-claim-draft'" (onClick)="this.deleteClaim()">
                            {{ 'global.delete' | translate }}
                        </app-button>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="claim.claimDocuments && claim.claimDocuments.length > 0">
                <div class="divider w-full"></div>
                <div class="claim-card-footer">
                    <div class="mb-2 items-start justify-start self-stretch w-full grid grid-cols-12">
                        <!-- Factura de compra del cliente final o de factura emitida a la tienda: -->
                         <div class="flex flex-col lg:flex-row items-start  lg:items-center col-span-11 gap-2 min-w-[180px]" >

                            <span class="typography-body-m-light whitespace-nowrap">{{'cacademy.related_documents' |translate}}:</span>
                            <div class="flex flex-row w-full gap-2">
                            <div *ngFor="let document of claim.claimDocuments.slice(0, 4)">
                            <a
                                (click)="getDocument(claim.id, document.versionId, document.title, document.fileExtension)"
                                download
                                style="cursor:pointer;"
                                gtm-label="file_download-claims-documents"
                                class="flex items-center gap-1 max-w-full text-primary-default leading-snug"
                            >
                                <svg class="flex-shrink-0" xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <path
                                    d="M6.625 19.6488C6.15833 19.6488 5.771 19.4948 5.463 19.1868C5.15433 18.8782 5 18.4905 5 18.0238V15.6488H6V18.0238C6 18.1905 6.06267 18.3362 6.188 18.4608C6.31267 18.5862 6.45833 18.6488 6.625 18.6488H17.375C17.5417 18.6488 17.6873 18.5862 17.812 18.4608C17.9373 18.3362 18 18.1905 18 18.0238V15.6488H19V18.0238C19 18.4905 18.846 18.8782 18.538 19.1868C18.2293 19.4948 17.8417 19.6488 17.375 19.6488H6.625ZM12 15.8738L8.45 12.3488L9.175 11.6238L11.5 13.9488V5.29883H12.5V13.9488L14.825 11.6238L15.55 12.3488L12 15.8738Z"
                                    fill="#365BCA"
                                />
                                </svg>
                                <span class="break-all line-clamp-1 text-sm">
                                {{ document.title }}.{{ document.fileExtension }}
                                </span>
                            </a>
                            </div>
                            <!-- Mostrar "..." si hay más de 4 -->
                            <div *ngIf="claim.claimDocuments.length > 4" class="text-primary-default ml-2">
                            ...
                            </div>
                            </div>

       
                        </div>
                        <a (click)="this.downloadAllDocuments(claim.id)" download class="col-span-1 cursor-pointer flex items-center text-primary-default justify-end">
                            <!-- {{ 'my_claims.download_all_documents' | translate }} -->
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                                <path
                                    d="M6.625 19.6488C6.15833 19.6488 5.771 19.4948 5.463 19.1868C5.15433 18.8782 5 18.4905 5 18.0238V15.6488H6V18.0238C6 18.1905 6.06267 18.3362 6.188 18.4608C6.31267 18.5862 6.45833 18.6488 6.625 18.6488H17.375C17.5417 18.6488 17.6873 18.5862 17.812 18.4608C17.9373 18.3362 18 18.1905 18 18.0238V15.6488H19V18.0238C19 18.4905 18.846 18.8782 18.538 19.1868C18.2293 19.4948 17.8417 19.6488 17.375 19.6488H6.625ZM12 15.8738L8.45 12.3488L9.175 11.6238L11.5 13.9488V5.29883H12.5V13.9488L14.825 11.6238L15.55 12.3488L12 15.8738Z"
                                    fill="#365BCA"
                                />
                            </svg>
                        </a>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
